import { splitEvery } from 'ramda';

var isArray = function isArray(val) {
  return Array.isArray(val);
};

var isObject = function isObject(val) {
  return val instanceof Object && !isArray(val);
};

var isPair = function isPair(val) {
  return isArray(val) ? !(val.length > 2) : false;
};

var isArrayOfObjects = function isArrayOfObjects(items) {
  return items.filter(function (item) {
    return !isObject(item);
  }).length === 0;
};

var isArrayOfPairs = function isArrayOfPairs(items) {
  return items.filter(function (item) {
    return !isPair(item);
  }).length === 0;
};

var isMixtureOfObjectsAndArrays = function isMixtureOfObjectsAndArrays(items) {
  return !isArrayOfObjects(items) && !isArrayOfPairs(items);
};

var organiseObjectListToPairs = function organiseObjectListToPairs(columns) {
  return splitEvery(2, columns);
};

var containsForeignObjectType = function containsForeignObjectType(items) {
  return items.filter(function (item) {
    return !isObject(item) && !isArray(item);
  }).length !== 0;
};

export var organiseColumnsIntoPairs = function organiseColumnsIntoPairs(columns) {
  if (isMixtureOfObjectsAndArrays(columns) || containsForeignObjectType(columns)) {
    throw new Error('Columns: must contain array of either arrays (pairs) or objects');
  }

  if (isArrayOfObjects(columns)) {
    return organiseObjectListToPairs(columns);
  }

  return columns;
};